import React from 'react';
import { useRequestData } from 'wsm-common-data';
import PropTypes from 'prop-types';

const VehiclePrice = ({ vehiclePrice }) => {
	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	return (
		vehiclePrice && (
			<div
				className={`font-weight-bold mr-4 ${
					isMobile ? 'ddc-font-size-xxlarge' : 'ddc-font-size-xlarge'
				}`}
			>
				{vehiclePrice}
			</div>
		)
	);
};

export default VehiclePrice;

VehiclePrice.propTypes = {
	vehiclePrice: PropTypes.string
};
